import { Navigate } from 'react-router';

import { areaForPrincipal, useSession } from '../session';
import { NoWebAccessPage } from '../pages/NoWebAccessPage';
import { AREA_HOME, PATHS } from './paths';

/**
 * `/` is not a page. It is a question: where does this person belong?
 *
 * Answering it here rather than rendering something means there is exactly one
 * place that decides, and it decides from the server's answer about the
 * principal's role -- never from a preference, a previous visit or anything the
 * browser remembered, because the browser remembers nothing.
 */
export function AreaHome() {
  const session = useSession();

  if (session === null) {
    return <Navigate to={PATHS.login} replace />;
  }

  const area = areaForPrincipal(session.principal);
  if (area === null) {
    return <NoWebAccessPage />;
  }

  return <Navigate to={AREA_HOME[area]} replace />;
}
